import React from 'react';

import {
  styled,
  Box
} from '@mui/material';
import {
  BaseWidget,
  Timeline
} from 'modules';

import * as dataService from './dataService';



const ContainerBox = styled(Box)({
  minWidth: 288
});

export interface IProps {
  returnAuthorizationId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.returnAuthorizationId);

  return (
    <ContainerBox>
      <BaseWidget.FC>
        <Timeline.FC steps={queryTuple.data.steps} />
      </BaseWidget.FC>
    </ContainerBox>
  );
};
